import script from "./StaffDetailDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaffDetailDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./StaffDetailDrawer.vue?vue&type=style&index=0&id=309e58e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309e58e9"]])

export default __exports__